import { createContext, useContext, useEffect } from 'react';
import { useExtensions } from './extension-hooks';

export enum DisplayModes {
	FullScreen,
	FullScreenOverflowed,
	Padded,
	TouchScreen //mobile/tablet
}

export type RouteCrumb = { pathOverride?: string; search?: string; title: string };

export type CurrentPageResource = {
	id: string;
	name: string;
	sub?: string;
	type: string;
};

export const ShellContext = createContext<{
	currentResource?: CurrentPageResource;
	routeCrumb?: RouteCrumb;
	setCurrentResource: (resource?: CurrentPageResource) => void;
	setRouteCrumb: (c?: RouteCrumb) => void;

	subTitle: string[];
	setSubTitle: (st: string[], routeCrumb?: RouteCrumb) => void;
	setDisplayMode: (dm: DisplayModes) => void;
}>({
	currentResource: undefined,
	routeCrumb: undefined,
	setCurrentResource: () => {},
	setDisplayMode: () => {},
	setRouteCrumb: () => {},
	setSubTitle: () => {},
	subTitle: []
});

export const useShellContext = () => useContext(ShellContext);

export const useTitle = (title: string) => {
	const titlePrefix = useExtensions('shell.title')[0];
	const { subTitle } = useContext(ShellContext);

	const documentTitle = [titlePrefix, title];

	if (subTitle.length > 0) {
		documentTitle.push(...subTitle);
	}
	const stringTitle = documentTitle.join(' | ');

	useEffect(() => {
		document.title = stringTitle;
	}, [stringTitle]);

	return document.title;
};

// for pages rendered from the CorePage()
// - event wizard, call list wizard, form, campaign builder
export const checkTitles = (crumbs: { title: string }[], subTitles: string[]) => {
	if (crumbs.length === 1) {
		return [crumbs[0].title, ...subTitles];
	}
	let result: string[] = [];
	crumbs?.map(c => result.push(c.title));
	return [...result, ...subTitles];
};
